// extracted by mini-css-extract-plugin
export default {"text":"_1fFDp","activity":"_2-5Bk"};